import TermsLayout from "@layouts/terms";
import type { NextPage } from "next";

interface TermsPageProps {}

const Terms: NextPage<TermsPageProps> = ({}: TermsPageProps) => {
  return <TermsLayout />;
};

// export async function getStaticPaths(context: any) {
//     return { paths: [], fallback: true };
// }
// This function gets called at build time on server-side.
// It won't be called on client-side, so you can even do
// direct database queries.
export async function getStaticProps(params: any) {
  return {
    props: {},
  };
}

export default Terms;
